<template>
  <div>
    <contact-form :title="contactTitle" hiddenName="origin" hiddenValue="Key findings download">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-title">
              <h3>Thank you for contacting us! <br /></h3>
              <div class="gures-btn pt-2">
                <a href="/assets/files/key-findings-2020.zip" class="theme-btn"
                  >Download 2020 key findings</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </contact-form>
  </div>
</template>

<script>
import ContactForm from '@/components/ContactForm';
export default {
  data() {
    return {
      contactTitle: 'Please fill the following form<br> to access the key-findings download page'
    };
  },
  components: {
    ContactForm
  }
};
</script>

<style lang="scss" scoped>
.error {
  color: red;
}
</style>
